"use client";

import { Button } from "@/components/ui/button";
import { useState } from "react";
import forge from "node-forge";

export default function RSATools() {
  const [action, setAction] = useState("idle");
  const [encryptedKey, setEncryptedKey] = useState("");
  const [decryptedKey, setDecryptedKey] = useState("");
  const [password, setPassword] = useState("");

    const  handleDecrypt =() => {
      setAction("decrypting");
      try {
        const privateKey = forge.pki.decryptRsaPrivateKey(encryptedKey, password);
        if (privateKey) {
          const pem = forge.pki.privateKeyToPem(privateKey);
          setDecryptedKey(pem);
        } else {
          setDecryptedKey("Decryption failed: incorrect password or key format.");
        }
      } catch (err) {
        setDecryptedKey("Decryption failed");
      } finally {
        setAction("idle");
      }
    }

    const handleClear =() =>{
      setPassword('')
      setEncryptedKey('')
      setDecryptedKey('')
    }

  return (
    <main className="flex flex-col items-center justify-between gap-6 mb-4">
      <h1 className="text-2xl font-bold mb-4">Private Key Decrypter</h1>
      <div className="flex flex-col gap-2">
        <label htmlFor="encrypted-key" className="semi-bold">
          Encrypted Private Key
        </label>
        <textarea
          id="encrypted-key"
          className="p-2 border rounded"
          rows={10}
          cols={50}
          placeholder="Enter Key Here"
          value={encryptedKey}
          onChange={(e) => setEncryptedKey(e.target.value)}
        />
      </div>
      <div className="flex gap-4">
        <input
          type="password"
          className="p-2 border rounded w-56"
          placeholder="Enter a secret passphrase"
          value={password}
          onKeyDown={(e)=> e.key === 'Enter' ? handleDecrypt : null }
          onChange={(e) => setPassword(e.target.value)}
        />

        <Button onClick={handleDecrypt} disabled={action != "idle"}>
          Decrypt
        </Button>
        <Button variant={'destructive'} onClick={handleClear} disabled={action != "idle"}>
          Clear
        </Button>
      </div>

      <div className="flex flex-col gap-2">
        <label htmlFor="decrypted-key" className="semi-bold">
          Decrypted Private Key
        </label>
        <textarea
          id="decrypted-key"
          className="p-2 border rounded"
          rows={10}
          cols={50}
          placeholder="Decypted Key"
          value={decryptedKey}
          readOnly
        />
      </div>
    </main>
  );
}
